import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=0110dd38&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=0110dd38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0110dd38",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';import TouchPan from 'quasar/src/directives/TouchPan.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});qInstall(component, 'directives', {TouchPan});
